import { render, staticRenderFns } from "./skuAlarmStock.vue?vue&type=template&id=b0229f88&"
import script from "./skuAlarmStock.vue?vue&type=script&lang=js&"
export * from "./skuAlarmStock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports